<template>
  <div class="mainClass">
    <!-- Institute Table -->
    <div class="container mt-4">
      <h2 class="text-center mb-4">Account Details</h2>
      <div class="table-responsive shadow rounded">
         <h5>Total Accounts: {{ totalAccounts }}</h5>
        <table class="table table-striped table-bordered">
          <thead class="bg-primary text-white">
            <tr>
              <th>Acc ID</th>
              <th>User Name</th>
              <th>Teacher NIC</th>
              <th>Contact No</th>
              <th>Start Date</th>
              <th>End Date</th>
              <th>Payment Status</th>
              <th>Status</th>
              <th>Total Price</th>
              <th>Add Payment</th>
              <th>View Payment</th>
              <th>More</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="account in accounts" :key="account.id"  :class="{ 'table-secondary': getPaymentStatus(account.end_date) === 'Acc Expired' }">
              <td>{{ account.id }}</td>
              <td>{{ account.user ? account.user.first_name : 'N/A' }}</td>
              <td>{{ account.teacher ? account.teacher.teacher_nic : 'N/A' }}</td>
              <td>{{ account.teacher ? account.teacher.contact : 'N/A' }}</td>
              <td>{{ account.start_date }}</td>
              <td>{{ account.end_date }}</td>
              <td>
                <span
                  class="badge"
                  :class="getPaymentStatus(account.end_date) === 'Active' ? 'bg-success' : 'bg-danger'"
                >
                  {{ getPaymentStatus(account.end_date) }}
                </span>
              </td>
              <td>{{ account.account_status.status_name }}</td>
              <td>{{ account.pkg_total_price }}</td>
              <td>
                <button
                  @click="getAccountDetails(account.id)"
                  class="btn btn-outline-info btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target="#addPaymentModal"
                >
                  <i class="bi bi-plus-square"></i> Add
                </button>
              </td>
              <td>
                <button
                  @click="getPaymentDetails(account.id)"
                  class="btn btn-outline-warning btn-sm"
                  data-bs-toggle="modal"
                  data-bs-target="#viewPaymentModal"
                >
                  <i class="bi bi-eye"></i> View
                </button>
              </td>
              <td>
                <button
                  @click="morePaymentDetails(account.id)"
                  class="btn btn-outline-danger btn-sm"
                >
                  <i class="bi bi-three-dots"></i> More
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- Loading Spinner -->
    <div v-if="loading" class="d-flex justify-content-center my-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!-- No Data Found Message -->
    <div v-else-if="accounts.length === 0" class="text-center my-4">
      <p class="text-muted fs-5">No data found</p>
    </div>
    <!-- Pagination -->
<div class="d-flex justify-content-center mt-3" v-if="totalPages > 1">
  <nav>
    <ul class="pagination">
      <li class="page-item" :class="{ disabled: currentPage === 1 }">
        <button class="page-link" @click="changePage(currentPage - 1)">
          Previous
        </button>
      </li>

      <li
        class="page-item"
        v-for="page in totalPages"
        :key="page"
        :class="{ active: currentPage === page }"
      >
        <button class="page-link" @click="changePage(page)">
          {{ page }}
        </button>
      </li>

      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
        <button class="page-link" @click="changePage(currentPage + 1)">
          Next
        </button>
      </li>
    </ul>
  </nav>
</div>

      </div>
    </div>

    <!-- Modal Add Payment -->
    <div
      class="modal fade"
      id="addPaymentModal"
      tabindex="-1"
      aria-labelledby="addPaymentModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title" id="addPaymentModalLabel">Account Details</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <AddPayment :account="selectedAddAccount" />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal View Payment -->
    <div
      class="modal fade"
      id="viewPaymentModal"
      tabindex="-1"
      aria-labelledby="viewPaymentModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title" id="viewPaymentModalLabel">Payment Details</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <ViewPayment :payment="selectedViewPayment" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import necessary components
import axios from "axios";
import AddPayment from "@/components/Payment/AddPayment.vue";
import ViewPayment from "@/components/Payment/ViewPayment.vue";

export default {
  name: "InstituteTable",
  components: {
    AddPayment,
    ViewPayment,
  },
  data() {
    return {
      loading: true, // Initial state
      accounts: [],
      selectedAddAccount: null,
      selectedViewPayment: null,
      currentPage: 1,
    totalPages: 1,
    totalAccounts: 0,
    };
  },
  mounted() {
    this.fetchAccounts();
  },

  watch: {
  accounts: {
    handler(newAccounts) {
      const today = new Date();
      newAccounts.forEach(account => {
        const endDate = new Date(account.end_date);
        if (endDate < today && account.account_status_id !== 4) {
          // Only call backend update — do not manually set status name
          this.updateAccountStatus(account.id);
        }
      });
    },
    deep: true,
    immediate: true,
  },
},

  methods: {

  async updateAccountStatus(accountId) {
  try {
    // Make PUT request and assign to response
    const response = await axios.put(`/update-account-status/${accountId}`, {
      account_status_id: 4,
    });

    // If response is successful, re-fetch accounts
    if (response.data.message === 'Account status updated') {
      await this.fetchAccounts();
    }

    console.log(`Account ${accountId} marked as expired`);
  } catch (error) {
    console.error('Error updating account status:', error);
  }
},

    // async fetchAccounts() {
    //   this.loading = true;
    //   try {
    //     const response = await axios.get("/get-all-accounts");
    //     this.accounts = response.data;
    //   } catch (error) {
    //     console.error("Error fetching accounts:", error);
    //   } finally {
    //     this.loading = false;
    //   }
    // },

//     async fetchAccounts() {
//   this.loading = true;
//   try {
//     const response = await axios.get("/get-all-accounts");
//     this.accounts = response.data;

//     // Auto-update expired accounts
//     const today = new Date();
//     for (const account of this.accounts) {
//       const endDate = new Date(account.end_date);
//       if (endDate < today && account.account_status_id !== 4) {
//         await this.updateAccountStatus(account.id);
//       }
//     }

//   } catch (error) {
//     console.error("Error fetching accounts:", error);
//   } finally {
//     this.loading = false;
//   }
// },
async fetchAccounts(page = 1) {
  this.loading = true;
  try {
    const response = await axios.get(`/get-all-accounts?page=${page}`);
    this.accounts = response.data.accounts.data;
        this.currentPage = response.data.accounts.current_page;
        this.totalPages = response.data.accounts.last_page; // ✅ fix here
        // this.lastPage = response.data.accounts.last_page;
        this.totalAccounts = response.data.total_accounts;

    // Auto-update expired accounts
    const today = new Date();
    for (const account of this.accounts) {
      const endDate = new Date(account.end_date);
      if (endDate < today && account.account_status_id !== 4) {
        await this.updateAccountStatus(account.id);
      }
    }
  } catch (error) {
    console.error("Error fetching accounts:", error);
  } finally {
    this.loading = false;
  }
},
changePage(page) {
    if (page >= 1 && page <= this.totalPages) {
      this.fetchAccounts(page);
    }
  },
    async getAccountDetails(id) {
      try {
        const response = await axios.get(`/get-account-by-id/${id}`);
        this.selectedAddAccount = response.data;
      } catch (error) {
        console.error("Error fetching account details:", error);
      }
    },
    async getPaymentDetails(accountId) {
      try {
        const response = await axios.get(`/get-payments-by-account/${accountId}`);
        this.selectedViewPayment = response.data;
      } catch (error) {
        console.error("Error fetching payment details:", error);
      }
    },
    morePaymentDetails(id) {
      this.$router.push({ name: "MorePayment", query: { accountId: id } });
    },
    getPaymentStatus(endDate) {
      const today = new Date();
      const accountEndDate = new Date(endDate);
      return accountEndDate >= today ? "Active" : "Acc Expired";
    },
  },
};
</script>

<style scoped>
.mainClass {
  width: 100%;
  padding: 20px 0;
}
.table th,
.table td {
  text-align: center;
  vertical-align: middle;
}
.table th {
  background-color: #0d6efd;
  color: white;
}
.table-responsive {
  max-width: 100%;
  overflow-x: auto;
  border-radius: 8px;
}
button {
  margin: 2px;
}
.modal-content {
  border-radius: 10px;
}
</style>
